import { Mappable } from "../_shared/mappable.class";

export class CueConfig extends Mappable<CueConfig> {
  cueConfigId: number;
  bucketName: string;
  name: string;
  lastModified: Date;
  path: string;
  configType: CueConfigType
  value: any;
}

export enum CueConfigType {
  EngineConfig = 1,
  AppConfig = 2
}

export const DEFAULT_APP_CONFIG = {
  versionSplit: 0,
  versionTwoUrl: "",
  versionTwoLogVisible: false,
  clientImageUrl: "",
  clientThemeColor: "#EA7125",
  FAQ: [
      {
        title: "What is CUE Live",
        body: "CUE Live uses music to sync your device to the show."
      },
      {
        title: "How do I Activate CUE Live",
        body: "To join the Light Show, simply have the \"Live\" page open when prompted."
      },
      {
        title: "What is the maximum range of the CUE system?",
        body: "CUE's range is determined by volume: the louder your speaker system, the farther the data will travel to mobile devices. Our signals have successfully transmitted over 200 yards to crowds of over 120,000 users."
      },
      {
        title: "Why does my phone say \"Waiting to Sync?\"",
        body: "At designated times while in venue, the app syncs to the videos and music. Wait for the prompts to join, then open the \"Live\" page."
      }
    ],
  usesMqttDryRun: false,
  disableTriviaFlash: false,
  usesMqtt: true,
  requestReview: true,
  demoTriggerSingle: true,
  demoTriggerURL: "https://s3.amazonaws.com/demo-assets.cueaudio.com/default-demo-trigger-461.wav",
  demoTrigger: "461",
  demoLightShow: true,
  demoSelfieCam: true,
  demoTrivia: true,
  demoMessaging: false,
  demoDJMode: false,
  rankQueryDelayTime: 20,
  rankerQueryTimeout: 47,
  triviaMaxDelayTime: 3,
  rankQueryRetryInterval: 5,
  photoPermissionTitle: null,
  photoPermissionBody: null,
  automaticPhotographyText: null,
  automaticPhotographySelfieText: null,
  showListenerLabel: true,
  listenerLabelText: "listening...",
  listenerLabelTextAndroid: "listening...",
  demoText: null,
  demoTrackURL: "https://s3.amazonaws.com/demo-assets.cueaudio.com/default-demo.mp3",
  sections: null,
  sectionSelectorIsEnabled:false,
  unavailableTitle: "Light Show Unavailable Tonight!",
  unavailableText: "Please check back soon",
  unavailableButtonText: "OK",
  unavailableDirectionsText: "Light Show Unavailable Tonight",
  unavailableUpdateTitle: "Update Required",
  unavailableUpdateText: "Please update your app to participate in the light show!",
  unavailableUpdateButtonText: "OK",
  useSpinner: false,
  micViewTitle: "TO JOIN THE SHOW...",
  micViewSubtitle: "In order to participate",
  micViewBody: "Phones need to be able to \"hear\" ultrasonic signals to activate the light show",
  menuTextOne: "LIVE",
  menuTextTwo: "DEMO",
  menuTextThree: "HELP",
  menuTextFour: "INFO",
  menuTextFive: "EXIT",
  menuOneEnabled:true,
  menuTwoEnabled:true,
  menuThreeEnabled:true,
  menuFourEnabled:true,
  menuFiveEnabled:true,
  showInstructional:false,
  shareToVideoboardText:"Share to Video Board",
  SC_instructionalViewTitle: "Synchronized Selfie Cam",
  SC_instructionalViewBodyRight1: "Select 'Allow' to the following permission prompts.",
  SC_instructionalViewBodyRight2: "Point your camera.",
  SC_instructionalViewBodyRight3: "Smile!",
  customMenuCells:null,
  triviaAdditionalText:null,
  triviaAdditionalUrls:null,
};
